/**
 * 另存为分析看板弹框组件
 *
 * @author By AICode
 * @date 2026-03-19
 */
<template>
  <a-modal
    title="另存为分析看板"
    :visible="visible"
    :confirm-loading="loading"
    ok-text="确认"
    cancel-text="取消"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
      <a-form-item label="名称">
        <a-input
          :max-length="20"
          v-decorator="[
            'name',
            {
              rules: [
                { required: true, message: '名称不能为空' },
                { max: 20, message: '名称最多20个字符' },
                { pattern: /^\S+$/, message: '名称不能包含空格' },
              ],
            },
          ]"
          placeholder="请输入名称，最多20个字符，不能包含空格"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { Modal, Form, Input } from 'ant-design-vue'

export default {
  name: 'AddDashboard',
  components: {
    'a-modal': Modal,
    'a-form': Form,
    'a-form-item': Form.Item,
    'a-input': Input,
  },
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  watch: {
    // 弹框打开时重置表单，避免上次填写内容残留 - By AICode
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.form.resetFields()
        })
      }
    },
  },
  methods: {
    // 校验通过后将表单值传给父组件 - By AICode
    handleOk() {
      this.form.validateFields((err, values) => {
        if (err) return
        this.loading = true
        this.$emit('ok', values)
        this.loading = false
      })
    },

    // 取消关闭弹框 - By AICode
    handleCancel() {
      this.$emit('cancel')
    },
  },
}
</script>
